import React from 'react';
import { FaExclamationCircle } from 'react-icons/fa';
import { ModalHeader, ModalTitle, ModalTitleIcon, ModalFooter, ButtonWrapper, ModalText, ModalTextQuestion, } from './ConfirmationModal.styled';
import { Modal } from '../modal';
import { ModalContent } from '../modal/content';
import { Button } from '../../button';
const ConfirmationModal = ({ id, visible, cancel, handleConfirm, header, description, question, cancelButtonText, confirmButtonText, confirmButtonType, width, }) => {
    const onCancel = () => cancel();
    const onProceed = () => handleConfirm();
    return (React.createElement(Modal, { id: id, width: width || 480, preventClose: true, closeButton: false, active: visible, close: onCancel },
        React.createElement(ModalContent, null,
            React.createElement(ModalHeader, null,
                React.createElement(ModalTitleIcon, null,
                    React.createElement(FaExclamationCircle, null)),
                React.createElement(ModalTitle, null, header)),
            React.createElement(ModalText, null,
                React.createElement("span", null, description),
                question && (React.createElement(ModalTextQuestion, null,
                    React.createElement("span", null, question)))),
            React.createElement(ModalFooter, null,
                React.createElement(ButtonWrapper, null,
                    React.createElement(Button, { size: "xs", onClick: onCancel }, cancelButtonText),
                    React.createElement(Button, { size: "xs", color: confirmButtonType, onClick: onProceed }, confirmButtonText))))));
};
ConfirmationModal.defaultProps = {
    question: 'Are you sure you want to change?',
    cancelButtonText: 'Cancel',
    confirmButtonText: 'Yes, Proceed',
    confirmButtonType: 'primary',
};
export default ConfirmationModal;
//# sourceMappingURL=ConfirmationModal.js.map